module.exports = __webpack_public_path__ + "static/media/inter-regular.4dd66a11.woff2";